import { Injectable } from '@angular/core';
import { BaseService } from './rest/base.service';
import { OAuthToken } from '../models/oauth-token.model';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { AuthorizationService } from './authorization.service';
import { MessageService } from './message.service';
import { CacheService } from './cache.service';
import { UrlHelper } from '../utils/url-helper';

@Injectable({
  providedIn: 'root'
})
export class TokenService extends BaseService<OAuthToken> {

  constructor(
    http: HttpClient,
    authorization: AuthorizationService,
    messages: MessageService,
    cache: CacheService
  ) {
    super(http, authorization, messages, cache);

    this.apiBaseUrl = UrlHelper.trimUrl(AppConfigService.settings.oauthUrl);
  }

  protected endpointUri = '';

  getAll(): Observable<OAuthToken[]> {
    throw new Error('Method not implemented.');
  }

  /**
   * Fetch a short-living token for file-downloads which require a token-parameter
   *
   * @returns {Observable<OAuthToken>}
   * @memberof TokenService
   */
  public getFileToken(): Observable<OAuthToken> {
    return this.getRequestCustom(this.apiBaseUrl + '/Authorization/FileToken');
  }

  get(id: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  add(entity: OAuthToken): Observable<any> {
    throw new Error('Method not implemented.');
  }

  update(entity: OAuthToken): Observable<any> {
    throw new Error('Method not implemented.');
  }

  delete(id: string): Observable<{}> {
    throw new Error('Method not implemented.');
  }



}
